function windowedSlice<T>(arr: Array<T>, size: number): Array<Array<T>> {
  const result = [];
  let i = 0;

  while (i < arr.length) {
    if (i + size > arr.length) {
      result.push(arr.slice(i, arr.length));
      break;
    }
    result.push(arr.slice(i, i + size));
    i += size;
  }

  return result;
}

function humanReadableArray(arr: Array<string>, locale: string): string {
  if (arr.length === 0) {
    return '';
  } else if (arr.length == 1) {
    return arr[0];
  } else {
    const last = arr[arr.length - 1];
    const rest = arr.slice(0, arr.length - 1);

    if (locale === 'en') {
      return rest.join(", ") + " and " + last;
    } else {
      return rest.join("、") + "及び" + last;
    }
  }
}

export {
    windowedSlice,
    humanReadableArray,
}